import QRCode from 'qrcode';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Draws the pairing code onto a canvas.
 *
 * The code lives in this component's props and in the pixels it draws, nowhere else — it is never
 * written to storage, never put in the address bar, and never logged. Whoever holds it could link
 * their own device to the branch's WhatsApp account, so the shortest possible life is the point.
 */
export function PairingCode({ value }: { value: string }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!canvas.current) return;
    void QRCode.toCanvas(canvas.current, value, { width: 264, margin: 1 });
  }, [value]);

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="rounded-xl bg-white p-3">
        <canvas ref={canvas} aria-label={t('whatsapp.pairing.qrLabel')} />
      </div>
      <ol className="list-inside list-decimal space-y-1 text-sm text-muted-foreground">
        <li>{t('whatsapp.pairing.step1')}</li>
        <li>{t('whatsapp.pairing.step2')}</li>
        <li>{t('whatsapp.pairing.step3')}</li>
      </ol>
    </div>
  );
}
